import React from "react";
import { GiftIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { bonuses } from "../../data/landing";
export function Bonuses() {
  return <section className="bg-cream py-16 sm:py-20" data-id="element-108" data-mp="1cl6258j3xigj">
      <div className="mx-auto max-w-4xl px-4" data-id="element-109" data-mp="1clzc0idd4o2w">
        <div className="text-center" data-id="element-110" data-mp="18jkuc1lfjud7">
          <span className="inline-flex items-center gap-2 rounded-full bg-peach px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider text-navy" data-id="element-111" data-mp="18km668a9skvz">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="257hchawimxqj" /> Included free today
          </span>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-113" data-mp="208xrbcpqxpz8">
            5 exclusive bonuses <em className="italic text-skydeep" data-id="element-114" data-mp="1ralpsfncd7s0">worth $197</em>
          </h2>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-4xl space-y-12 sm:space-y-16 sm:px-4" data-id="element-115" data-mp="kujhm25kdx24">
        {bonuses.map(b => <article key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10" data-id="element-116" data-mp="ftvrdip5tk8y">
            <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full md:rounded-3xl" loading="lazy" data-id="element-117" data-mp="1etev87eftq7d" />
            <div className="mt-5 px-4 md:mt-0 md:px-0" data-id="element-118" data-mp="15trttllpkkeb">
              <div className="flex items-center gap-3" data-id="element-119" data-mp="15vbbngn0j3i7">
                <span className="rounded-lg bg-navy px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-120" data-mp="1aqqny45dgrci">Bonus #{b.number}</span>
                <span className="text-sm font-semibold text-ink/60" data-id="element-121" data-mp="w1cc8pebpxty">
                  Value: <span className="line-through" data-id="element-122" data-mp="10v6vxstxict1">${b.value}</span> <span className="font-extrabold text-cta" data-id="element-123" data-mp="n30oqw8r7g5q">FREE</span>
                </span>
              </div>
              <h3 className="mt-3 font-display text-2xl font-extrabold leading-tight text-navy sm:text-3xl" data-id="element-124" data-mp="r3axuhruemot">{b.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-ink/75" data-id="element-125" data-mp="d4tboohl5i90">{b.text}</p>
              <p className="mt-4 text-[16px] font-bold text-skydeep" data-id="element-126" data-mp="i2cp5m6glqzw">{b.tagline}</p>
            </div>
          </article>)}
      </div>

      <div className="mx-auto mt-12 max-w-4xl px-4" data-id="element-127" data-mp="2jueio24nbjp4">
        <CTAButton label="I want the 5 free bonuses" data-id="element-128" data-mp="2f0sekycjso4x" />
      </div>
    </section>;
}